import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import axios from "../../helper/axios";

const ExportProducts = ({}) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const allData = { category: ["Diamond"], isAll: 1 };
    try {
      const response = await axios.post("/product_read", allData);
      const sortedProducts = response.data.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setProducts(sortedProducts);
    } catch (error) {
      console.error(error.response.data);
    }
  };

  const convertToCSV = (data, columns) => {
    const csv = Papa.unparse({
      fields: columns,
      data: data.map((item) => columns.map((col) => item[col])),
    });
    return csv;
  };

  const filename = "Diamond_Table"; // Replace with your desired filename
  const columns = [
    "product_price",
    "product_name",
    "stone_type",
    "carat",
    "product_image",
    "matching_band",
    "in_stock",
    "category_id_fk",
    "metal_id_fk",
    "product_type_id_fk",
    "settings_id_fk",
    "shape_id_fk",
    "style_id_fk",
    "color_id_fk",
    "clarity_id_fk",
    "cut_id_fk",
    "product_sku",
    "collection_id_fk",
    "size",
  ];

  const exportCSV = () => {
    const csvData = convertToCSV(products, columns);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${filename}.csv`);
  };

  return (
    <>
      <div
        className="modal fade"
        id="exportModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exportModalLabel">
                Export Products
              </h5>
              <button
                type="button"
                className="close btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{products.length} products available</p>
              {products.length > 0 ? (
                <button className="btn btn__primary" onClick={exportCSV}>
                  Export as CSV
                </button>
              ) : (
                <p>No products available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExportProducts;
